import $ from 'jquery';
import ajax from '@swisslife/shared-ui/src/utils/ajax/js/ajax';

export type ReCaptchaCallbackFunction = (config: IReCaptchaGlobalConfig) => any | never;
export type IncreaseReCaptchaIdFunction = () => any | never;

export interface IReCaptchaGlobalConfig {
	idBase: string;
	reCaptchaId: number;
	apiLoaded: boolean;
	apiLoading: boolean;
	callbacks: ReCaptchaCallbackFunction[];
	increase: IncreaseReCaptchaIdFunction;
}

export const reCaptchaGlobalConfig: IReCaptchaGlobalConfig = {
	idBase: 'sl-recaptcha-',
	reCaptchaId: 1,
	apiLoaded: false,
	apiLoading: false,
	callbacks: [],
	increase: () => (window as any).reCaptchaGlobalConfig.reCaptchaId++,
};

(window as any).reCaptchaGlobalConfig = (window as any).reCaptchaGlobalConfig || reCaptchaGlobalConfig;

const loadReCaptcha = (loadCallback: ReCaptchaCallbackFunction) => {
	const config = (window as any).reCaptchaGlobalConfig;
	if (config.apiLoaded) {
		loadCallback(config);
		return;
	}

	if (config.apiLoading) {
		config.callbacks.push(loadCallback);
		return;
	}

	config.callbacks.push(loadCallback);
	config.apiLoading = true;

	(window as any).onReCaptchaLoad = () => {
		config.callbacks.forEach((callbackFn: ReCaptchaCallbackFunction) => {
			callbackFn(config);
		});
		config.apiLoaded = true;
		config.apiLoading = false;
	};

	const locale = $('html').attr('lang') || '';

	ajax(`https://www.google.com/recaptcha/api.js?hl=${locale}&onload=onReCaptchaLoad&render=explicit`, {
		dataType: 'script',
	});
};

const fetchReCaptcha = (): Promise<IReCaptchaGlobalConfig> => {
	return new Promise((resolve) => {
		loadReCaptcha((config) => {
			resolve(config);
		});
	});
};

interface IReCaptchaOptions {
	$element: JQuery;
	sitekey: string;
	onVerified: () => void;
}

export class ReCaptcha {
	public isLoaded: boolean = false;
	private $element: JQuery;
	private sitekey: string;
	private uid: string;
	private idBase: string;
	private widgetId: string;
	private reCaptchaInstance: any;
	private onVerified: () => void;

	constructor(options: IReCaptchaOptions) {
		this.$element = options.$element;
		this.sitekey = options.sitekey;
		this.onVerified = options.onVerified;
	}

	public fetch = async () => {
		const config = await fetchReCaptcha();
		this.idBase = config.idBase;
		this.isLoaded = config.apiLoaded;

		this.uid = this.idBase + (window as any).reCaptchaGlobalConfig.increase();
		this.$element.attr('id', this.uid);

		this.reCaptchaInstance = (window as any).grecaptcha;

		this.widgetId = this.reCaptchaInstance.render(this.uid, {
			sitekey: this.sitekey,
			theme: 'light',
			size: 'invisible',
			badge: 'inline',
			callback: this.onVerified,
		});
	};

	public execute = async (): Promise<boolean> => {
		if (!this.reCaptchaInstance.getResponse(this.widgetId)) {
			await this.reCaptchaInstance.execute(this.widgetId);
			return false;
		}
		return true;
	};
}
